import { NSARouterMakerResult } from "namirasoft-account-react";
import { SortItem } from "namirasoft-core";
import { BudgetRow, MemoryRow, ValidatorRow, WiperRow } from "namirasoft-inference";
import { LogGroupRow } from "namirasoft-log";
import { NamirasoftMap } from "namirasoft-site-map";
import { IBaseComponentProps, NSBox, NSBoxEntity, NSColumn, NSInfoProps } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

export interface InferencerCommonFieldsValue
{
	validator_id: string | null;
	budget_id: string | null;
	memory_id: string | null;
	wiper_id: string | null;
	log_group_id: string | null;
}

export interface InferencerCommonFieldsHide
{
	validator?: boolean;
	budget?: boolean;
	memory?: boolean;
	wiper?: boolean;
	log_group?: boolean;
}

export interface InferencerCommonFieldsProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
	hide?: InferencerCommonFieldsHide;
	info_entity?: string;
}

export default class InferencerCommonFields extends Component<InferencerCommonFieldsProps>
{
	static EMPTY: InferencerCommonFieldsValue = { validator_id: null, budget_id: null, memory_id: null, wiper_id: null, log_group_id: null };

	private NSBoxEntity_Validator = createRef<NSBoxEntity<ValidatorRow>>();
	private NSBoxEntity_Budget = createRef<NSBoxEntity<BudgetRow>>();
	private NSBoxEntity_Memory = createRef<NSBoxEntity<MemoryRow>>();
	private NSBoxEntity_Wiper = createRef<NSBoxEntity<WiperRow>>();
	private NSBoxEntity_LogGroup = createRef<NSBoxEntity<LogGroupRow>>();

	getValue(checkError: boolean = false): InferencerCommonFieldsValue
	{
		return {
			validator_id: this.NSBoxEntity_Validator.current?.getValueOne(checkError) ?? null,
			budget_id: this.NSBoxEntity_Budget.current?.getValueOne(checkError) ?? null,
			memory_id: this.NSBoxEntity_Memory.current?.getValueOne(checkError) ?? null,
			wiper_id: this.NSBoxEntity_Wiper.current?.getValueOne(checkError) ?? null,
			log_group_id: this.NSBoxEntity_LogGroup.current?.getValueOne(checkError) ?? null,
		};
	}

	setValue(value: Partial<InferencerCommonFieldsValue>)
	{
		this.NSBoxEntity_Validator.current?.setValue(value.validator_id ?? null);
		this.NSBoxEntity_Budget.current?.setValue(value.budget_id ?? null);
		this.NSBoxEntity_Memory.current?.setValue(value.memory_id ?? null);
		this.NSBoxEntity_Wiper.current?.setValue(value.wiper_id ?? null);
		this.NSBoxEntity_LogGroup.current?.setValue(value.log_group_id ?? null);
	}

	private getInfo(anchor: string): NSInfoProps | undefined
	{
		if (!this.props.info_entity)
			return undefined;
		return { link: `https://namirasoft.com/inference/console-guide/${this.props.info_entity}/#field-${anchor}` };
	}

	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
		let hide = this.props.hide ?? {};
		return (
			<NSColumn>
				{!hide.validator && (
					<NSBoxEntity<ValidatorRow>
						ref={this.NSBoxEntity_Validator}
						{...this.props}
						title="Validator"
						required={false}
						info={this.getInfo("validator")}
						multiple={false}
						table={namirasoft.inference.tables.validator}
						getValue={(item) => item.id}
						getTitle={(item) => item.name}
						getSort={() => new SortItem(namirasoft.inference.tables.validator, namirasoft.inference.tables.validator.columns.name, true)}
						style={{ width: "100%", maxWidth: NSBox.width.triple }}
					/>
				)}
				{!hide.budget && (
					<NSBoxEntity<BudgetRow>
						ref={this.NSBoxEntity_Budget}
						{...this.props}
						title="Budget"
						required={false}
						info={this.getInfo("budget")}
						multiple={false}
						table={namirasoft.inference.tables.budget}
						getValue={(item) => item.id}
						getTitle={(item) => item.name}
						getSort={() => new SortItem(namirasoft.inference.tables.budget, namirasoft.inference.tables.budget.columns.name, true)}
						style={{ width: "100%", maxWidth: NSBox.width.triple }}
					/>
				)}
				{!hide.memory && (
					<NSBoxEntity<MemoryRow>
						ref={this.NSBoxEntity_Memory}
						{...this.props}
						title="Memory"
						required={false}
						info={this.getInfo("memory")}
						multiple={false}
						table={namirasoft.inference.tables.memory}
						getValue={(item) => item.id}
						getTitle={(item) => item.name}
						getSort={() => new SortItem(namirasoft.inference.tables.memory, namirasoft.inference.tables.memory.columns.name, true)}
						style={{ width: "100%", maxWidth: NSBox.width.triple }}
					/>
				)}
				{!hide.wiper && (
					<NSBoxEntity<WiperRow>
						ref={this.NSBoxEntity_Wiper}
						{...this.props}
						title="Wiper"
						required={false}
						info={this.getInfo("wiper")}
						multiple={false}
						table={namirasoft.inference.tables.wiper}
						getValue={(item) => item.id}
						getTitle={(item) => item.name}
						getSort={() => new SortItem(namirasoft.inference.tables.wiper, namirasoft.inference.tables.wiper.columns.name, true)}
						style={{ width: "100%", maxWidth: NSBox.width.triple }}
					/>
				)}
				{!hide.log_group && (
					<NSBoxEntity<LogGroupRow>
						ref={this.NSBoxEntity_LogGroup}
						{...this.props}
						title="Log Group"
						required={false}
						info={this.getInfo("log-group")}
						multiple={false}
						table={namirasoft.log.tables.log_group}
						getValue={(item) => item.id}
						getTitle={(item) => item.name}
						getSort={() => new SortItem(namirasoft.log.tables.log_group, namirasoft.log.tables.log_group.columns.name, true)}
						style={{ width: "100%", maxWidth: NSBox.width.triple }}
					/>
				)}
			</NSColumn>
		);
	}
}